import React, { useState } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';
import { useSelector } from 'react-redux';
import SelectInput from '@Components/Input/SelectInput';
import ButtonGroup from '@Components/ButtonGroup';

function SelectProjectModal({ isOpen, toggle, onSubmit }) {
  const { projects } = useSelector((state) => state.user);
  const options = projects.map((item) => ({ label: item.name, value: item.id }));
  const [value, setValue] = useState(options[0].value);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <div className="p-1 d-flex justify-content-between align-items-center">
        <span className="text-uppercase font-weight-bold">Chọn dự án</span>
        <Button color="link" className="p-0" onClick={toggle}>
          <Icon.X color="#828282" />
        </Button>
      </div>
      <ModalBody>
        <SelectInput
          inputCol="12"
          options={options}
          setValue={(name, val) => setValue(val)}
          defaultValue={value}
        />
        <ButtonGroup
          className="py-1"
          primary="Xác nhận"
          primaryOnClick={() => onSubmit(value)}
          secondaryOnClick={toggle}
        />
      </ModalBody>
    </Modal>
  );
}

SelectProjectModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default SelectProjectModal;
